module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-about-doctors"
  }, _vm._l((_vm.props.doctors), function(doctor, i) {
    return _c('div', {
      key: i,
      staticClass: "custom-about-doctors__doctor"
    }, [_c('div', {
      staticClass: "custom-about-doctors__col-left"
    }, [(i === 0) ? _c('div', {
      attrs: {
        "id": "dr-hingle"
      }
    }) : _vm._e(), (i === 1) ? _c('div', {
      attrs: {
        "id": "dr-patel"
      }
    }) : _vm._e(), _c('div', {
      staticClass: "custom-about-doctors__title",
      domProps: {
        "innerHTML": _vm._s(doctor.title)
      }
    }), _c('div', {
      staticClass: "custom-about-doctors__tagline",
      domProps: {
        "innerHTML": _vm._s(doctor.tagline)
      }
    }), _c('div', {
      staticClass: "custom-about-doctors__bio",
      domProps: {
        "innerHTML": _vm._s(doctor.bio)
      }
    }), _c('div', {
      staticClass: "custom-about-doctors__tabs-container"
    }, [_c('div', {
      staticClass: "custom-about-doctors__tabs"
    }, _vm._l((doctor.tabs), function(tab, j) {
      return _c('div', {
        key: j,
        staticClass: "custom-about-doctors__tab",
        class: {
          'custom-about-doctors__tab--active': _vm.activeTabs[i].tab === j
        },
        domProps: {
          "innerHTML": _vm._s(tab.tab)
        },
        on: {
          "click": function($event) {
            return _vm.selectTab(i, j)
          }
        }
      })
    }), 0), _vm._l((doctor.tabs), function(tab, k) {
      return _c('div', {
        key: k,
        staticClass: "custom-about-doctors__content",
        class: {
          'custom-about-doctors__content--active': _vm.activeTabs[i].tab === k
        },
        domProps: {
          "innerHTML": _vm._s(tab.content)
        }
      })
    })], 2)]), _c('div', {
      staticClass: "custom-about-doctors__col-right"
    }, [_c('div', {
      directives: [{
        name: "waypoint",
        rawName: "v-waypoint",
        value: ({
          active: true,
          callback: _vm.onWaypointImage
        }),
        expression: "{ active: true, callback: onWaypointImage }"
      }],
      staticClass: "custom-about-doctors__waypoint"
    }), _c('div', {
      staticClass: "custom-about-doctors__image-mask"
    }, [_c('div', {
      staticClass: "custom-about-doctors__image",
      style: ({
        backgroundImage: 'url(' + doctor.image + ')'
      })
    })])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97792fa6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-about-doctors/custom-about-doctors.pug
// module id = 570
// module chunks = 1